export const ErrorSelectors = {
  loadingOverlayErrorButtons: '.loading-overlay__error-buttons',
  loadingOverlayErrorButtonsRetryButton: '.loading-overlay__error-buttons .btn-primary',
  criticalError: '.critical-error',
  criticalErrorRestartButton: '#critical-error-button',
  errorPage: '.error-page'
}
